import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { SetColorsService } from 'core'

@Component({
  selector: 'bmprod-beat-page',
  templateUrl: './bmprod-beat-page.component.html',
  styleUrls: ['./bmprod-beat-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodBeatPageComponent implements OnInit {
  colorSettingsMode = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
